import { createContext, useState } from "react";

export const AppContext = createContext();

export function AppProvider({children}){
    const [isOpenLogin, setIsOpenLogin] = useState(false);
    

    return (
        <AppContext.Provider value={{isOpenLogin, setIsOpenLogin}}>
            {children}
        </AppContext.Provider>
    )
}